export const CE_SET_BEE_UID = "CE_SET_BEE_UID";
export const ceSetBeeUID = (uid) => ({
  type: CE_SET_BEE_UID,
  bee_uid: uid,
});

export const CE_SET_BEE_TOKEN_FAILURE = "CE_SET_BEE_TOKEN_FAILURE";
export const ceFetchBeeTokenFailure = () => ({
  type: CE_SET_BEE_TOKEN_FAILURE,
});
